import { Box, Chip, Divider, Paper, Stack, TextField, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSnackbar } from 'notistack';
import ActionMenu from './ActionMenu';
import useResponsive from '../../../../Hooks/useResponsive';
import { Icon } from '@iconify/react';
import headerImg from './skillx.png';

const PaidCartItems = ({ paidCartItems }) => {
  const { enqueueSnackbar } = useSnackbar();
  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');

  const [filterCourseData, setFilterCourse] = useState([]);

  //   // Handle deleting a course
  //   const handleDelete = (courseId) => {

  //     const updatedCourses = availableCartItems?.filter(
  //       (item) => item.id != courseId
  //     );
  //     enqueueSnackbar("Deleted Successfully...!", {
  //       variant: "success",
  //     });
  //     setAvailableCartItems(updatedCourses);
  //   };

  // useEffect(() => {
  //   const filterData = availableCartItems?.filter(
  //     (item) => item.wishList == false
  //   );
  //   setFilterCourse(filterData);
  // }, [availableCartItems]);
  //   useEffect(() => {
  //     if (filterCourseData) {
  //       const sum = filterCourseData.reduce(
  //         (acc, course) => acc + (parseInt(course.discountedAmount) || 0),
  //         0
  //       );
  //       const totalDiscount = filterCourseData.reduce(
  //         (acc, course) => acc + (parseInt(course.discount) || 0),
  //         0
  //       );
  //       const totalAmount = filterCourseData.reduce(
  //         (acc, course) => acc + (parseInt(course.MRP) || 0),
  //         0
  //       );
  //       const totalPayingAmount = filterCourseData.reduce(
  //         (acc, course) => acc + (parseInt(course.paidAmt) || 0),
  //         0
  //       );
  //       setTotalPayingAmount(totalPayingAmount);
  //       setTotalAmount(totalAmount);
  //       setTotalDiscount(totalDiscount);
  //       setTotalDiscountedAmount(sum);
  //     }
  //   }, [filterCourseData]);

  const handleInputChange = (e, courseId, field) => {
    const { value, type, checked } = e.target;

    // Update the specific field (checkboxes, text fields, etc.)
    const updatedCourses = paidCartItems.map((item) => {
      if (item.id === courseId) {
        // Validate if MRP or discount fields are empty before updating
        if (
          item.id === courseId &&
          type === 'checkbox' &&
          (item.MRP == '' || item.discount == '' || item.noOfSessions == '')
        ) {
          enqueueSnackbar('Some fields are empty...!', {
            variant: 'error',
          });
          return item; // Don't update if there's an empty field
        }

        // Calculate discountedAmount if either amount or discount is updated
        let updatedItem = {
          ...item,
          [field]: type === 'checkbox' ? checked : value,
        };

        if (field === 'MRP' || field === 'discount') {
          const amount = field === 'MRP' ? value : item.MRP || 0;
          const discount = field === 'discount' ? value : item.discount || 0;
          const discountedAmount = amount - discount;

          updatedItem = { ...updatedItem, discountedAmount };
        }
        if (field === 'admissionFee') {
          updatedItem = { ...updatedItem, admissionFee: checked ? 500 : 0 };
        }

        return updatedItem;
      }
      return item;
    });

    // setAvailableCartItems(updatedCourses);
  };

  return (
    <Box>
      {paidCartItems?.length == 0 ? null : (
        <>
          <Typography variant="h6">Enrolled Courses</Typography>
          <Divider sx={{ borderStyle: 'dashed', borderBottomWidth: 2 }} />
        </>
      )}

      <AnimatePresence>
        {paidCartItems?.map((item, index) => {
          return (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -50 }}
              transition={{ duration: 0.5 }}
            >
              <Paper
                sx={{
                  backgroundColor: '#edf2fb',
                  mt: 3,
                  padding: 2,
                  borderRadius: 3,
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Stack direction={mdUp ? 'row' : 'column'} spacing={2}>
                  <Box sx={{ maxWidth: 100, minWidth: 70 }}>
                    <img
                      style={{ borderRadius: '50%', border: '3px solid #fdfdfdff' }}
                      src={headerImg}
                      height={60}
                      width={60}
                    />
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, fontWeight: 'bolder' }}>
                        {item.courseName.replace(/[_-]/g, ' ')}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Text fields for session count, amount, discount, and discounted amount */}
                  <motion.div
                    initial={{ opacity: 0, x: -30 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    transition={{ duration: 0.5 }}
                  >
                    <TextField
                      type="number"
                      disabled
                      label="no: of sessions"
                      value={item.noOfSessions || ''}
                      onChange={(e) => handleInputChange(e, item.id, 'noOfSessions')}
                      sx={{
                        // width: "150px",
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '30px',
                          padding: '0px',
                        },
                        '& .MuiOutlinedInput-input': {
                          height: '30px',
                          padding: '5px 10px',
                          fontSize: '0.8rem',
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: '0.8rem',
                          top: '-5px',
                        },
                        '& .MuiInputLabel-shrink': {
                          top: '0',
                        },
                      }}
                    />
                  </motion.div>

                  {/* <Box> */}
                  {/* <Stack direction={"column"} spacing={1}> */}
                  <motion.div
                    initial={{ opacity: 0, x: -30 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    transition={{ duration: 0.7 }}
                  >
                    <TextField
                      label="Amount"
                      type="number"
                      disabled
                      value={item.MRP || ''}
                      onChange={(e) => handleInputChange(e, item.id, 'MRP')}
                      sx={{
                        // width: "150px",
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '30px',
                          padding: '0px',
                        },
                        '& .MuiOutlinedInput-input': {
                          height: '30px',
                          padding: '5px 10px',
                          fontSize: '0.8rem',
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: '0.8rem',
                          top: '-5px',
                        },
                        '& .MuiInputLabel-shrink': {
                          top: '0',
                        },
                      }}
                    />
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, x: -30 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    transition={{ duration: 0.5 }}
                  >
                    <TextField
                      label="Discount"
                      type="number"
                      disabled
                      value={item.discount || ''}
                      onChange={(e) => handleInputChange(e, item.id, 'discount')}
                      sx={{
                        // width: "150px",
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '30px',
                          padding: '0px',
                        },
                        '& .MuiOutlinedInput-input': {
                          height: '30px',
                          padding: '5px 10px',
                          fontSize: '0.8rem',
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: '0.8rem',
                          top: '-5px',
                        },
                        '& .MuiInputLabel-shrink': {
                          top: '0',
                        },
                      }}
                    />
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, x: -30 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    transition={{ duration: 0.5 }}
                  >
                    <TextField
                      label="Discounted Amount"
                      disabled
                      type="number"
                      value={item.netAmt || ''}
                      onChange={(e) => handleInputChange(e, item.id, 'discountedAmount')}
                      sx={{
                        // width: "150px",
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '30px',
                          padding: '0px',
                        },
                        '& .MuiOutlinedInput-input': {
                          height: '30px',
                          padding: '5px 10px',
                          fontSize: '0.8rem',
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: '0.8rem',
                          top: '-5px',
                        },
                        '& .MuiInputLabel-shrink': {
                          top: '0',
                        },
                      }}
                    />
                    {parseFloat(item.admissionFee) > 0 ? (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          pt: 0.5,
                        }}
                      >
                        <Chip
                          variant="outlined"
                          size="small"
                          color="success"
                          label={`adm fee: ${item.admissionFee}`}
                          icon={<Icon icon="mdi:approve" width="12" height="12" />}
                          sx={{ height: 15, fontSize: 7 }}
                        />
                      </Box>
                    ) : null}
                  </motion.div>
                  {/* </Stack>
                      </Box> */}
                  <motion.div
                    initial={{ opacity: 0, x: -30 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    transition={{ duration: 0.9 }}
                  >
                    <TextField
                      label="Paid Amount"
                      type="number"
                      disabled
                      value={item.totalPaidAmt || ''}
                      onChange={(e) => handleInputChange(e, item.id, 'paidAmt')}
                      sx={{
                        // width: "150px",
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '30px',
                          padding: '0px',
                        },
                        '& .MuiOutlinedInput-input': {
                          height: '30px',
                          padding: '5px 10px',
                          fontSize: '0.8rem',
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: '0.8rem',
                          top: '-5px',
                        },
                        '& .MuiInputLabel-shrink': {
                          top: '0',
                        },
                      }}
                    />
                    {item.emi ? (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          pt: 0.5,
                        }}
                      >
                        <Chip
                          variant="outlined"
                          color="primary"
                          size="small"
                          label="EMI"
                          sx={{ height: 15, fontSize: 7 }}
                        />
                      </Box>
                    ) : null}
                    {item.isProcessingFee ? (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          pt: 0.5,
                        }}
                      >
                        <Chip
                          variant="outlined"
                          color="primary"
                          size="small"
                          label="ProFee included"
                          sx={{ height: 15, fontSize: 7 }}
                        />
                      </Box>
                    ) : null}
                  </motion.div>
                  {/* ------------------------------action-menu-------------/ */}

                  <ActionMenu addNewPayment={true} paid={true} paidItem={item} item={item} />
                  {/* ------------------- */}
                </Stack>
              </Paper>
              {item.isRetention == 1 ? (
                <Stack
                  direction="row"
                  spacing={1}
                  justifyContent="center"
                  alignItems="center"
                  flexWrap="wrap"
                  useFlexGap
                  sx={{ pt: 1 }}
                >
                  <Chip
                    variant="filled"
                    color="primary"
                    size="small"
                    icon={<Icon icon="mdi:trending-up" width="16" height="16" />}
                    label="Upsell"
                    sx={{ fontSize: 12, fontWeight: 600 }}
                  />
                  {item.retentionExtraSessions ? (
                    <>
                      <Chip
                        variant="outlined"
                        color="primary"
                        size="small"
                        label={`+${item.retentionExtraSessions} sessions`}
                        sx={{ fontSize: 12 }}
                      />
                      <Chip
                        variant="outlined"
                        color="primary"
                        size="small"
                        label={`+₹${item.retentionExtraSaleAmount}`}
                        sx={{ fontSize: 12 }}
                      />
                      {item.retentionRemarks ? (
                        <Tooltip title={item.retentionRemarks.split(' | ').join(' • ')}>
                          <Chip
                            variant="outlined"
                            size="small"
                            icon={<Icon icon="mdi:information-outline" width="16" height="16" />}
                            label="remarks"
                            sx={{ fontSize: 12, cursor: 'pointer' }}
                          />
                        </Tooltip>
                      ) : null}
                    </>
                  ) : null}
                </Stack>
              ) : null}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Chip
                  icon={<Icon icon="mdi:rupee" />}
                  color={parseInt(item.paymentCompletionStatus) == 1 ? 'success' : 'warning'}
                  variant="outlined"
                  size="small"
                  label={parseInt(item.paymentCompletionStatus) == 1 ? 'Full Payment Done' : 'Partial Payment'}
                />
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'center', pt: 1 }}>
                <Chip
                  variant="outlined"
                  size="small"
                  color={item.enrollmentStatus == 0 ? 'error' : item.enrollmentStatus == 1 ? 'success' : 'warning'}
                  icon={
                    item.enrollmentStatus == 0 ? (
                      <Icon icon="radix-icons:cross-2" width="15" height="15" />
                    ) : item.enrollmentStatus == 1 ? (
                      <Icon icon="material-symbols:verified-outline" width="24" height="24" />
                    ) : (
                      <Icon icon="mingcute:time-line" width="24" height="24" />
                    )
                  }
                  label={
                    item.enrollmentStatus == 0 ? 'Inactive' : item.enrollmentStatus == 1 ? 'Active' : 'Temp Inactive'
                  }
                />
              </Box>
              {item?.isRetention == 2 ? (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    pt: 0.5,
                  }}
                >
                  <Chip
                    variant="outlined"
                    color="primary"
                    size="small"
                    label="Cross Sell"
                    sx={{ height: 15, fontSize: 7 }}
                  />
                </Box>
              ) : null}
              {item.selectedCurrency && (
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 0.5 }}>
                  <Chip
                    icon={<Icon icon="game-icons:money-stack" width="20" height="20" />}
                    size="small"
                    color="primary"
                    variant="outlined"
                    label={item.selectedCurrency == 1 ? 'INR' : item.selectedCurrency == 2 ? 'AED' : 'AED to INR'}
                  />
                </Box>
              )}
            </motion.div>
          );
        })}
      </AnimatePresence>
    </Box>
  );
};

export default PaidCartItems;
